<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_viii"></a><a id="contents"></a>CONTENTS</h2>
<p class="image1"><img alt="Image" src="images/line.jpg"/></p>
<p class="toc"><a href="#/xhtml/frontmatter01">A<span class="smallcaps">CKNOWLEDGMENTS</span></a></p>
<p class="toc"><a href="#/xhtml/frontmatter02">I<span class="smallcaps">NTRODUCTION</span></a></p>
<p class="toc"><a href="#/xhtml/chapter01">1. B<span class="smallcaps">EHEMOTH TO</span> D<span class="smallcaps">INOSAUR</span></a></p>
<p class="toc"><a href="#/xhtml/chapter02">2. L<span class="smallcaps">OWER</span>, U<span class="smallcaps">PPER</span>, M<span class="smallcaps">IDDLE</span></a></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3. W<span class="smallcaps">OMEN’S</span> W<span class="smallcaps">EAR</span></span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4. B<span class="smallcaps">RICKS AND</span> M<span class="smallcaps">ORTAR</span></span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5. W<span class="smallcaps">INDOW</span>-S<span class="smallcaps">HOPPING</span></span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6. R<span class="smallcaps">AZZLE</span>-D<span class="smallcaps">AZZLE</span></span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7. F<span class="smallcaps">LOORWALKERS</span>, F<span class="smallcaps">ASHIONISTS, AND</span> F<span class="smallcaps">OUNDERS</span></span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8. T<span class="smallcaps">HE</span> G<span class="smallcaps">OODS</span></span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9. A<span class="smallcaps">T</span> Y<span class="smallcaps">OUR</span> S<span class="smallcaps">ERVICE</span></span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. C<span class="smallcaps">HILDREN’S</span> W<span class="smallcaps">ONDERLAND</span></span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11. F<span class="smallcaps">ASHIONING THE</span> T<span class="smallcaps">EEN</span> M<span class="smallcaps">ARKET</span></span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12. E<span class="smallcaps">VERYTHING FOR THE</span> H<span class="smallcaps">OME</span></span></p>
<p class="toc"><span href="#/xhtml/backmatter" title="Link target outside of Sample">E<span class="smallcaps">PILOGUE</span></span></p>
<p class="toc"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">R<span class="smallcaps">EFERENCES</span></span></p>
<p class="toc"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">I<span class="smallcaps">NDEX OF</span> S<span class="smallcaps">TORES</span></span></p>
<p class="toc"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">I<span class="smallcaps">NDEX</span></span><a id="page_ix"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?16a857d1